import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Input from '../Input/Input';

const Checkbox = ({children, divClass, disabled, htmlId, inputClass, name, onChange, value}) => {
    const divClassValue = classNames(
        'checkbox',
        divClass
    );
    return(
        <div className={divClassValue}>
            <label
                htmlFor={htmlId}>
                <Input
                    checked={value}
                    className={inputClass}
                    disabled={disabled}
                    id={htmlId}
                    name={name}
                    onChange={onChange}
                    type="checkbox" />
                    {children}
            </label>
        </div>
    );
};

Checkbox.propTypes = {
    //Child component.
    children: PropTypes.node,
    //Class applied to div
    divClass: PropTypes.string,
    //Should input be disabled.
    disabled: PropTypes.bool,
    //Html id attribute.
    htmlId: PropTypes.string,
    //Class applied to input.
    inputClass: PropTypes.string,
    //Input name.
    name: PropTypes.string,
    //Function triggered when input value changed.
    onChange: PropTypes.func,
    //Input value
    value: PropTypes.bool,
};

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/base/Checkbox/Checkbox.js